import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@env/environment';
import { CredentialsService } from '@shared/services/web/credentials.service';
import { RedirectRouterService } from '@shared/services/web/redirect-router.service';
import {ToastrService} from "@shared/services/web/toastr.service";


/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private toastrService: ToastrService,
    private credentialService: CredentialsService,
    private redirectService: RedirectRouterService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next
      .handle(request)
      .pipe(catchError((error) => this.errorHandler(error)));
  }

  // Customize the default error handler here if needed
  private errorHandler(response: any): Observable<HttpEvent<any>> {
    if (!environment.production) {
      // Do something with the error
      if (response.status === 500)
        this.toastrService.error(response.error.message, 'Error en servidor');
    }

    if (response.error?.path === 'authorization') {
      this.credentialService.setCredentials().subscribe();
      this.redirectService.goToPage('/ingresar');
    }
    if (response.error?.path === 'token') {
      this.credentialService.setCredentials().subscribe();
      if (window.location.pathname.includes('tablero-de-usuario')) {
        setTimeout(() => {
          this.redirectService.goToPage('/ingresar');
        }, 3000);
      }
      this.toastrService.error('Tu sesión ha expirado.', 'Error' );
    }
    throw response;
  }
}
